import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "excludeLogo", "status", "wayfindingColors"];
import React from "react";
import styled from "styled-components";
import { shadows, spacing } from "../../dimensions";
import { mix } from "polished";
import BrandLogo from "../BrandLogo";
var TicketCardv2 = function TicketCardv2(_ref) {
  var children = _ref.children,
    _ref$excludeLogo = _ref.excludeLogo,
    excludeLogo = _ref$excludeLogo === void 0 ? false : _ref$excludeLogo,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? "primary" : _ref$status,
    wayfindingColors = _ref.wayfindingColors,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(TicketHeaderBorder, {
    excludeLogo: excludeLogo,
    status: status,
    wayfindingColors: status === "primary" ? wayfindingColors : undefined
  }), /*#__PURE__*/React.createElement(ChildrenWrapper, {
    $type: status,
    $wayfindingColors: wayfindingColors
  }, children));
};
var TicketHeaderBorder = function TicketHeaderBorder(_ref2) {
  var excludeLogo = _ref2.excludeLogo,
    status = _ref2.status,
    wayfindingColors = _ref2.wayfindingColors;
  return /*#__PURE__*/React.createElement(TicketHeaderBorderContainer, {
    $thinBorder: excludeLogo,
    $status: status,
    $wayfinding: wayfindingColors
  }, !excludeLogo && /*#__PURE__*/React.createElement(BrandLogo, {
    color: wayfindingColors === null || wayfindingColors === void 0 ? void 0 : wayfindingColors.foreground
  }));
};
export default TicketCardv2;
export var Card = styled.div.withConfig({
  displayName: "TicketCardv2__Card",
  componentId: "sc-1akc5v-0"
})(["display:flex;flex-direction:column;flex-grow:1;border-radius:4px;overflow:hidden;background-color:", ";box-shadow:", ";"], function (props) {
  return props.theme.base.bg;
}, shadows.annular);
export var getBackgroundColor = function getBackgroundColor(type, wayfinding) {
  if (wayfinding && statusesWithWayfinding.includes(type)) {
    return wayfinding.background;
  } else {
    return "initial";
  }
};
export var ChildrenWrapper = styled.div.withConfig({
  displayName: "TicketCardv2__ChildrenWrapper",
  componentId: "sc-1akc5v-1"
})(["display:flex;flex-direction:column;flex-grow:1;"]);
export var TicketHeaderBorderContainer = styled.div.withConfig({
  displayName: "TicketCardv2__TicketHeaderBorderContainer",
  componentId: "sc-1akc5v-2"
})(["display:flex;width:100%;height:", ";padding:", ";background-color:", ";"], function (_ref3) {
  var $thinBorder = _ref3.$thinBorder;
  return $thinBorder ? spacing.lounge : spacing.amphitheatre;
}, function (_ref4) {
  var $thinBorder = _ref4.$thinBorder;
  return $thinBorder ? 0 : "0.3rem 0";
}, function (props) {
  var $status = props.$status,
    theme = props.theme,
    $wayfinding = props.$wayfinding;
  return getHeaderBackgroundColor($status, theme, $wayfinding);
});
export var statusesWithWayfinding = ["primary", "resale"];
var getHeaderBackgroundColor = function getHeaderBackgroundColor(status, theme, $wayfinding) {
  if ($wayfinding && statusesWithWayfinding.includes(status)) {
    var foreground = $wayfinding.foreground,
      background = $wayfinding.background;
    if (["#ffffff", "#fff"].includes(foreground.toLowerCase())) {
      return mix(0.1, "#000", background);
    } else {
      return mix(0.2, "#fff", background);
    }
  }
  var statusToColorDictionary = {
    disabled: theme.colors.status["default"],
    membership: theme.base.primary,
    primary: theme.base.primary,
    resale: theme.colors.resale,
    reserved: theme.base.primary,
    transfer: theme.colors.status["default"],
    upsell: theme.colors.base.primary,
    addedValue: theme.base.primary
  };
  return statusToColorDictionary[status];
};